/*global VariantSelects */
if (!customElements.get('vk-variant-radios')) {
  /*
  class VKVariantRadios extends VariantSelects {
    constructor() {
      super();

      this.finishTabs = this.querySelectorAll('.finishes--tab-container .finish-tab');

      this.finishTabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          const finish = event.currentTarget.dataset.finish;
          this.updateFinish(finish);
        });
      });
    }

    updateFinish(finish) {
      this.finishTabs.forEach((tab) => {
        tab.classList.remove('active');
      });

      this.querySelector(`.finishes--tab-container .finish-tab[data-finish="${finish}"]`).classList.add('active');

      this.querySelectorAll('.finishes--tab-content').forEach((tabContent) => {
        tabContent.classList.remove('active');
      });

      this.querySelector(`#tab-content--${finish}`).classList.add('active');
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
      mediaGalleries.forEach((mediaGallery) => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

      const vkCanvas = document.querySelectorAll(`[id^="VKCanvas-${this.dataset.section}"]`);
      // vkCanvas.forEach(canvas => canvas.updateCanvas(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.currentVariant));
      vkCanvas.forEach((canvas) => canvas.updateCanvas(this.currentVariant));

      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        const selectedValue = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;

        // Update Legend text with the selected option color value
        fieldset.querySelectorAll('legend span.vk-fieldset-value').forEach((span) => {
          span.textContent = selectedValue;
        });

        return selectedValue;
      });
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        const result = variant.options.map((option, index) => {
          return this.options[index] === option;
        });

        return result[0] === true;
      });
    }
  }
  */

  class VKVariantRadios extends VariantSelects {
    constructor() {
      super();

      this.finishTabs = this.querySelectorAll('.finishes--tab-container .finish-tab');

      this.finishTabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          const finish = event.currentTarget.dataset.finish;
          this.updateFinish(finish);
        });
      });
    }

    updateFinish(finish) {
      this.finishTabs.forEach((tab) => {
        tab.classList.remove('active');
      });

      this.querySelector(`.finishes--tab-container .finish-tab[data-finish="${finish}"]`).classList.add('active');

      this.querySelectorAll('.finishes--tab-content').forEach((tabContent) => {
        tabContent.classList.remove('active');
      });

      this.querySelector(`#tab-content--${finish}`).classList.add('active');
    }
  }

  customElements.define('vk-variant-radios', VKVariantRadios);
}
